/**
 * @generated SignedSource<<2a3953ce672c7b45fa6dd8413ffffebc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type IntegrationSyncDescription_integration$data = {
  readonly id: number;
  readonly " $fragmentSpreads": FragmentRefs<"IntegrationSyncStatus_integration">;
  readonly " $fragmentType": "IntegrationSyncDescription_integration";
};
export type IntegrationSyncDescription_integration$key = {
  readonly " $data"?: IntegrationSyncDescription_integration$data;
  readonly " $fragmentSpreads": FragmentRefs<"IntegrationSyncDescription_integration">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IntegrationSyncDescription_integration",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "IntegrationSyncStatus_integration"
    }
  ],
  "type": "integration",
  "abstractKey": null
};

(node as any).hash = "683bd2425bc59aa596bd10aa8e11e6f4";

export default node;
